import { Box, type BoxProps, Loader } from '@mantine/core';
import { calcDuration, type Duration } from 'cross-state';
import { useState, type ReactNode, useEffect } from 'react';

export interface LoadingIndicatorProps extends BoxProps {
  size?: 'full' | 'grow' | 'inline';
  label?: ReactNode;
  delay?: Duration;
}

export function LoadingIndicator({ size, label, delay, ...boxProps }: LoadingIndicatorProps) {
  const _delay = calcDuration(delay ?? 0);
  const [show, setShow] = useState(_delay <= 0);

  useEffect(() => {
    const timeout = setTimeout(() => setShow(true), _delay);
    return () => clearTimeout(timeout);
  }, [_delay]);

  return (
    show && (
      <Box
        {...boxProps}
        css={[
          {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '0.5rem',
          },
          size === 'full' && {
            width: '100dvw',
            height: '100dvh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          },
          size === 'grow' && {
            flex: 1,
            width: '100%',
            height: '100%',
          },
        ]}
      >
        <Loader size="1.2em" color="currentcolor" />
        {label ?? 'Loading...'}
      </Box>
    )
  );
}
